import { fetchManifest } from "./fetchManifest"

export async function fetchStickers(hash: string) {
    const manifest = await fetchManifest(hash)

    return manifest.stickers?.map(s => ({
        ...s,
        url: `${process.env.REACT_APP_CDN_BASE}/${hash}${s.url}`
    })) ?? []
}